import React from 'react';
import { InputField, Select, Skeleton } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';

import { ContextMenuContainer } from '../../../../../../components/ContextMenuContainer/ContextMenuContainer';

import { ReactComponent as SearchIcon } from './assets/searchIcon.svg';
import { Container, ContainerSelect, ContainerButton } from './Header.styles';

interface HeaderProps {
	communications: any;
	isLoadingCommunication: boolean;
	selectedCommunication: any;
	onSelectCommunication: any;
	branchOfficeOptions: any;
	selectedBranchOffice: any;
	isLoadingBranchOffice: any;
	handleSelectBranchOffice: any;
	onChangeSelectedSelector: any;
	selectedSector: any;
	onSearch?: any;
}

export const Header = ({
	communications,
	isLoadingCommunication,
	selectedCommunication,
	onSelectCommunication,
	branchOfficeOptions,
	selectedBranchOffice,
	isLoadingBranchOffice,
	handleSelectBranchOffice,
	onChangeSelectedSelector,
	selectedSector,
	onSearch,
}: HeaderProps) => {
	if (isLoadingCommunication || isLoadingBranchOffice) {
		return (
			<Container>
				<Skeleton width="330px" />
				<ContainerSelect>
					<Skeleton width="200px" />
					<Skeleton width="200px" />
					<Skeleton width="42px" />
				</ContainerSelect>
			</Container>
		);
	}

	return (
		<Container>
			<ContextMenuContainer
				communications={communications}
				selectedCommunication={selectedCommunication}
				onSelectCommunication={onSelectCommunication}
			/>
			<ContainerSelect>
				<Select
					id="branchOffice"
					disabled={isLoadingBranchOffice}
					placeholder="Selecione..."
					loading={isLoadingBranchOffice}
					label="Sucursal"
					required
					initialSelected={selectedBranchOffice}
					options={branchOfficeOptions}
					onChange={handleSelectBranchOffice}
				/>
				<InputField
					id="sector"
					label="Sector"
					placeholder="Escribe el sector"
					value={selectedSector}
					onChange={(value) => onChangeSelectedSelector(value)}
				/>
				<ContainerButton>
					<Button onClick={onSearch}>
						<SearchIcon />
					</Button>
				</ContainerButton>
			</ContainerSelect>
		</Container>
	);
};
